<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="tituloCard" *ngIf="!mostrarFormulario" [optionsExport]="false">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <h2 class="container float-left">{{ tituloForm }}</h2>
  <div class="row form-group">
    <div class="form-group col-md-6" style="display: flex;align-items: center;">
      <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
    <div class="form-group col-12 col-md-3">
      <div [formGroup]="formularioEstados" novalidate class="form-group">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
          [comboBox]="cmbEstadosFiltro" formControlName="estado" [control]="formulario.get('estado')"
          [label]="'Estado *'" [id]="'estado'">
        </app-lfsa-combo-box>
      </div>
    </div>
    <div class="form-group col-md-3" style="display: flex;align-items: center;">
      <button (click)="nuevo()" class={{DAT_BTNCSS.success}}>{{DAT_BTNS.agregar}}</button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <ag-grid-angular class="{{modulo.agGrid.class}}" #agGrid [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
        [paginationPageSize]="modulo.agGrid.paginacion" [pagination]="true" [frameworkComponents]="frameworkComponents"
        [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>

<app-lfsa-card [innTemplate]="enviarTemplateResport" [titulo]="tituloForm" *ngIf="mostrarFormulario">
</app-lfsa-card>
<ng-template #enviarTemplateResport>

  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-12">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Código SAP'" [label]="'Código SAP *'" [id]="'codigoSap'" formControlName="codigoSap"
          [control]="formulario.get('codigoSap')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Cédula Empleado'"
          [label]="'Cédula Empleado *'" [id]="'cedula'" formControlName="cedula" [control]="formulario.get('cedula')"
          (change)="getVendedor($event);" (keyup)="getVendedor($event);"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-9">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Nombre Empleado'" [label]="'Nombre Empleado *'" [id]="'nombreVendedor1'"
          formControlName="nombreVendedor1" [control]="formulario.get('nombreVendedor1')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-12">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Cargo Actual Nominal'" [label]="'Cargo Actual Nominal *'" [id]="'cargoNominal'"
          formControlName="cargoNominal" [control]="formulario.get('cargoNominal')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
          [comboBox]="listTiposDeVendedores" formControlName="tipoVendedorId"
          [control]="formulario.get('tipoVendedorId')" [label]="'Tipo de Vendedor *'" [id]="'tipoVendedorId'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Cargo Sueldo Variable'"
          [label]="'Cargo Sueldo Variable *'" [id]="'sueldoVariable'" formControlName="sueldoVariable"
          [control]="formulario.get('sueldoVariable')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4"
        style="display: flex;justify-content: center;flex-direction: column;align-items: start;">
        <label>Excepción de Sueldo Variable</label>
        <div>
          <input type="checkbox" formControlName="excepcionSueldo" [id]="'excepcionSueldo'">
          <span>{{ (formulario.get('excepcionSueldo').value) ? "SI" : "NO" }}</span>
        </div>
      </div>
      <div class="form-group col-12 col-md-4"
        style="display: flex;justify-content: center;flex-direction: column;align-items: start;">
        <label>Comisiona por personal a cargo</label>
        <div>
          <input type="checkbox" formControlName="comisionaPorPersonal" [id]="'comisionaPorPersonal'">
          <span>{{ comisionaPorPersonal ? "SI" : "NO" }}</span>
        </div>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
          [comboBox]="cmbEstados" formControlName="estado" [control]="formulario.get('estado')" [label]="'Estado *'"
          [id]="'estado'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Código Vacacionista'"
          [label]="'Código Vacacionista *'" [id]="'codigoVacacionista'" formControlName="codigoVacacionista"
          [control]="formulario.get('codigoVacacionista')" (change)="getVendedor($event);"
          (keyup)="getVendedor($event);"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-12">
        <app-lfsa-input [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Tipo de Vehículo (Fondo Vehicular)'" [label]="'Tipo de Vehículo (Fondo Vehicular)'"
          [id]="'tipoVehiculo'" formControlName="tipoVehiculo"
          [control]="formulario.get('tipoVehiculo')"></app-lfsa-input>
      </div>
    </div>
    <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones( $event )"
      [textBoton]="textBoton"></app-lfsa-botones-formulario>
  </div>

</ng-template>

<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'Editar Alta de Vendedor'" [idButton]="'buttonAbrirModal'"
  [idOpen]="'abrirModal'" [idClose]="'cerrarModal'"></app-lfsa-modal>
<ng-template #enviarModal>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese ID'"
          [label]="'ID *'" [id]="'idVendedor'" formControlName="idVendedor"
          [control]="formulario.get('idVendedor')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Fecha Registro'" [label]="'Fecha Registro *'" [id]="'fechaRegistro'"
          formControlName="fechaRegistro" [control]="formulario.get('fechaRegistro')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Código SAP'" [label]="'Código SAP *'" [id]="'codigoSap'" formControlName="codigoSap"
          [control]="formulario.get('codigoSap')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Cédula Empleado'"
          [label]="'Cédula Empleado *'" [id]="'cedula'" formControlName="cedula" [control]="formulario.get('cedula')"
          (change)="getVendedor($event);" (keyup)="getVendedor($event);"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-9">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Nombre Empleado'" [label]="'Nombre Empleado *'" [id]="'nombreVendedor1'"
          formControlName="nombreVendedor1" [control]="formulario.get('nombreVendedor1')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-12">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Cargo Actual Nominal'" [label]="'Cargo Actual Nominal *'" [id]="'cargoNominal'"
          formControlName="cargoNominal" [control]="formulario.get('cargoNominal')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
          [comboBox]="listTiposDeVendedores" formControlName="tipoVendedorId"
          [control]="formulario.get('tipoVendedorId')" [label]="'Tipo de Vendedor *'" [id]="'tipoVendedorId'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Cargo Sueldo Variable'"
          [label]="'Cargo Sueldo Variable *'" [id]="'sueldoVariable'" formControlName="sueldoVariable"
          [control]="formulario.get('sueldoVariable')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4"
        style="display: flex;justify-content: center;flex-direction: column;align-items: start;">
        <label>Excepción de Sueldo Variable</label>
        <div>
          <input type="checkbox" formControlName="excepcionSueldo" [id]="'excepcionSueldo'">
          <span>{{ (formulario.get('excepcionSueldo').value) ? "SI" : "NO" }}</span>
        </div>
      </div>
      <div class="form-group col-12 col-md-4"
        style="display: flex;justify-content: center;flex-direction: column;align-items: start;">
        <label>Comisiona por personal a cargo</label>
        <div>
          <input type="checkbox" formControlName="comisionaPorPersonal" [id]="'comisionaPorPersonal'">
          <span>{{ comisionaPorPersonal ? "SI" : "NO" }}</span>
        </div>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
          [comboBox]="cmbEstados" formControlName="estado" [control]="formulario.get('estado')" [label]="'Estado *'"
          [id]="'estado'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Código Vacacionista'"
          [label]="'Código Vacacionista *'" [id]="'codigoVacacionista'" formControlName="codigoVacacionista"
          [control]="formulario.get('codigoVacacionista')" (change)="getVendedor($event);"
          (keyup)="getVendedor($event);"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-12">
        <app-lfsa-input [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Tipo de Vehículo (Fondo Vehicular)'" [label]="'Tipo de Vehículo (Fondo Vehicular)'"
          [id]="'tipoVehiculo'" formControlName="tipoVehiculo"
          [control]="formulario.get('tipoVehiculo')"></app-lfsa-input>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-12 col-md-4"></div>
    <div class="form-group col-12 col-md-4">
      <button class="btn btn-success btn-block" [disabled]="formulario.invalid" (click)="actualizar()">
        <i class="fa fa-save"></i>
        Guardar</button>
    </div>
    <div class="form-group col-12 col-md-4"></div>
  </div>
</ng-template>